/** Punch-in result: the fixed span spliced into the take, saved as a NEW take (mono WAV from where the take starts). */
import { encodeWav } from "@/lib/wavEncoder";
import { fmtClock } from "@/lib/studioApi";
import { takeBuffer } from "@/components/recstudio/sessionEngine";
import { spliceTake, toMono } from "@/components/recstudio/takeRender";

const r3 = (v) => Math.round(v * 1000) / 1000;

export async function punchResult(engine, punch, aligned) {
  const base = await takeBuffer(engine, punch.baseTake);
  const end = Math.max(punch.start + 0.01, Math.min(punch.end, aligned.duration));
  const full = spliceTake(engine.ctx, base, aligned, punch.start, end);
  const from = Math.min(punch.baseTake.start_sec || 0, punch.start);
  return {
    buffer: full,
    cut: Math.max(0, punch.end - end),
    blob: encodeWav(toMono(engine.ctx, full, from)),
    name: `${punch.baseTake.name.replace(/ · fix [\d:]+$/, "")} · fix ${fmtClock(punch.start)}`.slice(0, 120),
    meta: { trim_head_sec: 0, start_sec: r3(from), punch: { from_take_id: punch.baseTake.id, start: r3(punch.start), end: r3(end) } },
  };
}
